import { BaseApiTemplateService } from "../shared/base-api-template-service.model";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Core2Config } from "../shared/core2Config";
import { WmsContainerModel } from "../../../../../models/aggregates/warehouse/index";
import { ApiVisa } from '../shared';
import { ApiResponseModel } from '../shared/api-response.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: "root" })
export class WarehouseContainerService extends BaseApiTemplateService<WmsContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouse-containers/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouse-containers/backoffice-ep";
    this.httpClient = http;
  }

  public getByCriteriaPost(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/query';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public generateContainerLabel(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    // let url = 'http://localhost:5000/core2/tnt/dm/erp/warehouse-containers/generate-container-label/backoffice-ep';
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url +  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouse-containers/generate-container-label/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public getContainersForAllocation(visa: ApiVisa): Observable<ApiResponseModel<any>> {
    // let url = 'http://localhost:5000/core2/tnt/dm/erp/warehouse-containers/generate-container-label/backoffice-ep';
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url +  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouse-containers/containers-for-allocation/backoffice-ep";
    }
    return this.httpClient.get<ApiResponseModel<any>>(
      url,
      this.getHttpHeader(visa)
    );
  }


  public createMulti(payload: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url  + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouse-containers/multi/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      payload,
      this.getHttpHeader(visa)
    );
  }
  
  public updateMulti(payload: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url  + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouse-containers/multi/backoffice-ep";
    }
    return this.httpClient.put<ApiResponseModel<any>>(
      url,
      payload,
      this.getHttpHeader(visa)
    );
  }

  public deleteMulti(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url  + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouse-containers/multi-delete/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
